import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MoreInformationModal } from '../MoreInformationModals';

const GiftMessageMoreInformationModal = ({ isModalOpen, onRequestClose }) => {
  const { t } = useTranslation();
  return (
    <MoreInformationModal
      isModalOpen={isModalOpen}
      onRequestClose={onRequestClose}
      contentList={[
        {
          title: t('paymentMethod'),
          description: t('giftMessageInfoModalPaymentMethodDesc'),
          icon: (
            <Icon
              name="payment-method"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          )
        },
        {
          title: `${t('po')}#`,
          description: t('giftMessageInfoModalPoDesc'),
          icon: (
            <Icon
              name="po"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          )
        },
        {
          title: t('costCenter'),
          description: t('giftMessageInfoModalCostCenterDesc'),
          icon: (
            <Icon
              name="cost-center"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          )
        }
      ]}
    />
  );
};

export default GiftMessageMoreInformationModal;
